import * as React from 'react';

interface SimpleDialogProps extends React.ClassAttributes<any> {
    title?: JSX.Element | string;
    content?: JSX.Element | string;
    dialogStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    setDialogPosition?: (width: number, height: number, callback: (top: number, left: number) => void) => void;
    hideCloseButton?: boolean;
    onClick?: () => void;
    onClose?: () => void;
}

interface SimpleDialogState {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
}

export class SimpleDialog extends React.Component<SimpleDialogProps, SimpleDialogState> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.dialogRef = React.createRef();
    }

    private dialogRef: any;

    componentDidMount(): void {
        if (typeof this.props.setDialogPosition === 'function') {
            if (this.dialogRef && this.dialogRef.current) {
                const w = this.dialogRef.current.offsetWidth;
                const h = this.dialogRef.current.offsetHeight;
                this.props.setDialogPosition(w, h, (top: number, left: number) => {
                    if (top !== this.state.top) {
                        this.setState({ top });
                    }
                    if (left !== this.state.left) {
                        this.setState({ left });
                    }
                });
            }
        }
    }

    render(): JSX.Element {
        const backgroundColor = (this.props.dialogStyle || {}).backgroundColor || 'rgba(255, 255, 255, 0.9)';
        return (
            <div
                ref={this.dialogRef}
                style={{
                    zIndex: 100000, position: 'absolute',
                    minWidth: 300, maxWidth: 500, minHeight: 50, maxHeight: 545, overflow: 'auto',
                    display: 'flex', flexDirection: 'column',
                    fontSize: 12, borderRadius: 5, border: '1px solid gray',
                    padding: '0 5px 5px 5px', backgroundColor,
                    top: this.state.top || 0,
                    left: this.state.left || 0,
                    ...(this.props.dialogStyle || {})
                }}
                onClick={this.props.onClick}
            >
                <div style={{
                    position: 'sticky', top: 0,
                    display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                    padding: '5px 0', fontWeight: 'bold', backgroundColor
                }}>
                    <div style={{ ...(this.props.titleStyle || {}) }}>
                        {this.props.title}
                    </div>
                    {!this.props.hideCloseButton &&
                        <div
                            style={{
                                fontSize: 15, backgroundColor: 'lightgray', padding: '0 4px', borderRadius: 5,
                                cursor: 'pointer'
                            }}
                            title='Schließen'
                            onClick={this.props.onClose}
                        >
                            ×
                        </div>
                    }
                </div>
                <div>
                    {this.props.content}
                </div>
            </div>
        );
    }
}
